import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  itemToEdit: {
    id: null,
    name: "",
    amount: "",
    type: "",
  },
};
const transactionEditSlice = createSlice({
  name: "transactionEdit",
  initialState,
  reducers: {
    setItemToEdit: (state, action) => {
      state.itemToEdit = action.payload;
    },
    reSetItemToEdit: (state) => {
      state.itemToEdit = initialState.itemToEdit;
    },
  },
});

export const transactionEditReducer = transactionEditSlice.reducer;
export const { setItemToEdit, reSetItemToEdit } = transactionEditSlice.actions;
